
export default function StatsSection() {
  return (
    <section className="py-16 bg-[#f5f5f5]">
      <div className="mx-auto px-6 lg:px-[15%]">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-4xl font-bold text-[#663333] mb-4">
            市场地位印证
          </h2>
          <p className="text-sm sm:text-lg text-gray-600">
            用数据说话，用实力证明
          </p>
        </div>

        {/* 核心数据看板 */}
        <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12 border-2 border-[#cc9966]">
          <div className="text-center mb-8">
            <div className="text-xl sm:text-2xl lg:text-4xl font-bold text-[#663333] mb-4">
              普洱茶年份茶全国销量第一品牌
            </div>
            <div className="text-lg sm:text-xl text-[#cc9966] font-semibold">
              尚普咨询权威认证
            </div>
            <div className="w-24 h-1 bg-[#cc9966] mx-auto mt-4"></div>
          </div>

          {/* 其他关键指标 */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
            <div className="text-center">
              <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#663333] mb-2">500+吨</div>
              <div className="text-sm sm:text-base text-gray-600">售出吨位</div>
            </div>
            <div className="text-center">
              <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#663333] mb-2">200000+单量</div>
              <div className="text-sm sm:text-base text-gray-600">售出单量</div>
            </div>
            <div className="text-center">
              <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#663333] mb-2">95-98%好评率</div>
              <div className="text-sm sm:text-base text-gray-600">综合好评率</div>
            </div>
          </div>
        </div>

        {/* 品质保证 */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-16">
          <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-[#cc9966]/20">
            <div className="w-16 h-16 flex items-center justify-center bg-[#cc9966] rounded-full mb-6">
              <i className="ri-building-2-fill text-2xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-[#663333] mb-4">源头把控</h3>
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
              深入云南核心产区，与500+藏家和茶厂建立长期合作关系，从源头确保茶叶品质以及极致性价比。
            </p>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-[#cc9966]/20">
            <div className="w-16 h-16 flex items-center justify-center bg-[#cc9966] rounded-full mb-6">
              <i className="ri-store-3-fill text-2xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-[#663333] mb-4">科学仓储</h3>
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
              恒温恒湿专业仓库，温度22-28℃，湿度60-70%，确保茶叶完美转化。
            </p>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-[#cc9966]/20">
            <div className="w-16 h-16 flex items-center justify-center bg-[#cc9966] rounded-full mb-6">
              <i className="ri-award-fill text-2xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-[#663333] mb-4">品质检验</h3>
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
              入库审评、年度体检、出厂检验三道标准化流程，层层把关品质。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
